import { render, staticRenderFns } from "./ListItems.vue?vue&type=template&id=027f172e&scoped=true&"
import script from "./ListItems.vue?vue&type=script&lang=js&"
export * from "./ListItems.vue?vue&type=script&lang=js&"
import style0 from "./ListItems.vue?vue&type=style&index=0&id=027f172e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f172e",
  null
  
)

export default component.exports